import React from 'react';
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

import mapMarkerIcon from '../static/img/map-marker-icon.png'
import infoIcon from '../static/img/icon-info.png'
import pootsyWhiteLogo from '../static/img/pootsy-logo-white.png'
import * as statusBadgeIcons from '../static/svg/booking-status-badge-icons'
import ModalLayout from "./shared/ModalLayout"

const noop = () => {}

export const JsonLd = ({ data }) => <script type="application/ld+json">{JSON.stringify(data)}</script>

export const UserNavLayout = ({ customClass = "", children }) => (
	<div className={"UserNavLayout " + customClass}>
		<div className="gradient-background"></div>
		<Link to="/"><img className="logo" alt="logo" src={pootsyWhiteLogo}/></Link>
		{children}
	</div>
)

export const BookingFlowStep = ({ headerContent, customClass, children }) => (
	<div className={"BookingFlowStep " + customClass}>
		<div className="top">
			<img className="picto" alt="picto" src={headerContent.picto}/>
			<PootsyTitle title={headerContent.title}/>
			<div className="subtitle">{headerContent.subtitle}</div>
		</div>
		{children}
	</div>
)

export const ErrorModal = ({ error, closeModal, localisedError }, context) => (
	<ModalLayout title={context.t('error_modal_title')} closeModal={closeModal} customClass="ErrorModal">
		{context.t(error)}
		{localisedError}
		<PootsyButton text={context.t('dismiss_error_modal')} onClick={closeModal}/>
	</ModalLayout>
)
ErrorModal.contextTypes = { t: PropTypes.func }

export const PootsyTitle = ({ title, customClass = "" }) => (
	<div className={"PootsyTitle " + customClass} role="heading">{title}</div>
)

export const PootsySubtitle = ({ subtitle }) => (
	<div className="PootsySubtitle" role="heading">{subtitle}</div>
)

export const PrimaryLink = ({ to = "#", label }) => (
	<Link className="PrimaryLink" to={to}>{label}</Link>
)

export const ExternalPrimaryLink = ({ to = "#", label }) => (
	<a className="PrimaryLink" rel="noreferrer noopener" target="_blank" href={to}>{label}</a>
)

export const PootsyButton = ({ text, disabled = false, onClick, theme = "default", dataset = {} }) => (
	<div role="button" className={"PootsyButton " + theme + (disabled ? " disabled" : "")}
		 onClick={disabled ? noop : onClick} {...dataset}
	>
		{text}
	</div>
)

export const PootsyDataDisplayer = ({ data = [], displayerLayout = "row", entriesLayout = "row" }) => (
	<div className={"pootsy-data-displayer " + displayerLayout}>
		{data.map(entry =>
			<div key={entry.label} className={"data-entry " + entriesLayout}>
				<div className="label">{entry.label}:</div>
				<div className="value">{entry.value}</div>
			</div>
		)}
	</div>
)

export const InfoButton = ({ text, icon = infoIcon }) => (
	<div className="InfoButton">
		<img className="icon" alt="" src={icon}/>
		<div className="tooltip">{text}</div>
	</div>
)

export const PootsyBox = ({ label, rightComponent }) => (
	<div className="PootsyBox">
		<div className="label">{label}</div>
		{rightComponent}
	</div>
)

const statusBadgeIconMap = {
	assigned: statusBadgeIcons.doneIcon,
	ongoing: statusBadgeIcons.timerRunningIcon,
	cancelled: statusBadgeIcons.cancelIcon,
	problem: statusBadgeIcons.warningIcon,
	finished: statusBadgeIcons.checkIcon
}
export const BookingStatusBadge = ({ status, t }) => {
	return (
		<div className={"BookingStatusBadge " + status}>
			<div className="icon">{statusBadgeIconMap[status]}</div>
			<div className="status">{t(status)}</div>
		</div>
	)
}

export const MapMarker = () => <img alt="marker" src={mapMarkerIcon} style={{ height: 45, transform: 'translate(-50%, -100%)' }}/>

export const DropdownMenu = ({ customClass = "", active = false, toggleDropdown, title, children }) => (
	<div className={"DropdownMenu " + customClass + (active ? " active" : "")} onClick={toggleDropdown}>
		<div className="dropdown-title">{title}</div>
		<div className="dropdown-menu">
			{React.Children.map(children, child => <div className="dropdown-item">{child}</div>)}
		</div>
	</div>
)



// WEBPACK FOOTER //
// ./src/components/DesignFunctions.js